const checkout_button = document.querySelector('.checkout-button');
  const checkout_hidden_button = document.querySelector('.hidden-checkout');
  checkout_button.addEventListener('click', function(event){
    event.preventDefault();

    fetch("cart.js")
      .then(function(response) {
        return response.json();
      })
      .then(function(data) {
        let has_delivery_item = false;
        for (let i = 0; i < data.items.length; i++) {
          const item = data.items[i];
          const item_title = item.title
          if (item_title.includes('Delivery: ') || item_title.includes('Pick up')) {
            has_delivery_item = true;
          }
        }
        if (has_delivery_item) {
          checkout_hidden_button.click();
        } else {
          const form = checkout_button.closest('form');
          for (const el of form.querySelectorAll("[required]")) {
            if (!el.reportValidity()) {
              checkout_hidden_button.click();
              return;
            }
          }

          let formData = {
            'items': [{
              'id': 41933558874268,
              'quantity': 1
            }]
          };

          if(default_selling_plan) {
            formData.items[0]['selling_plan'] = default_selling_plan
          }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(response => {
            checkout_hidden_button.click();
          })
          .catch((error) => {
            console.error('Error:', error);
          });
        }
      })
      .catch(function(err) {
        console.error('Error:', error);
      });
  });